import { CALLBACK_PATH } from "../routes.ts";

/** A page bundle under `/static/build/`. */
export type Entry = "stage" | "control" | "callback";

/** The stage: `stagePath` in `@eto/shared/paths.ts`. */
const STAGE_PAGE = new URLPattern({ pathname: "/workspaces/:workspaceId" });

/**
 * The bundle for a pathname: the stage, sign-in's callback, else the control
 * view (its own path, `stageControlPath`, and the root, where it shows the
 * workspace switcher alone).
 */
export const entryOf = (pathname: string): Entry =>
  pathname === CALLBACK_PATH
    ? "callback"
    : STAGE_PAGE.test({ pathname })
      ? "stage"
      : "control";
